import { createFileRoute, redirect } from "@tanstack/react-router";
import { SupportToolsLayout } from "~/modules/SupportTools/SupportToolsLayout";

const isSupportToolsEnabled = import.meta.env.VITE_SUPPORT_TOOLS_ENABLED === "true";

export const Route = createFileRoute("/_protected/support-tools")({
  beforeLoad: () => {
    if (!isSupportToolsEnabled) {
      throw redirect({ to: "/" });
    }
  },
  component: () => <SupportToolsLayout showHeader />,
});
